import React, { useEffect, useState } from "react";

import { useMediaQuery } from "@mui/material";
import BlueButton from "../../../components/BlueButton/BlueButton";
import { DataGrid } from "@mui/x-data-grid";
import { AdminsData, IntroductionPagesColumns } from "../../../SourceData";
import SwipeableModals from "../SwipeableModals/SwipeableModals";
import MessageModals from "../../../components/MessageModals/MessageModals";
import DeleteUser from "./../../../assets/delete.svg";
import AddGif from "./../../../assets/add-gif.gif";
import EditUser from "./../../../assets/edit-user.svg";
import ShowUser from "./../../../assets/show-user.svg";
import api from "../../../utils/api";

const IntroductionPages = () => {
  const isMobile = useMediaQuery("(max-width:767px)");
  const isTablet = useMediaQuery("(min-width: 768px) and (max-width: 1024px)");
  const [isOpen, setIsOpen] = useState(false);
  const [currentModalView, setCurrentModalView] = useState("createPage");
  const [openDelete, setOpenDelete] = useState(false);
  const [loading, setLoading] = useState(false);
  const [pages, setPages] = useState([]);
  const [selectedPage, setSelectedPage] = useState(null); // For editing/viewing
  const [itemToDelete, setItemToDelete] = useState(null); // For delete operation

  // Fetch social media links on component mount
  useEffect(() => {
    fetchSocialMedia();
  }, []);

  // Function to fetch social media links from API
  const fetchSocialMedia = async () => {
    try {
      setLoading(true);
      const res = await api.get("/slides?flag=welcome_screen");

      setPages(res.data.data);
    } catch (error) {
      console.error("Failed to fetch social media links:", error);
      // You can integrate with your react-notify library here
    } finally {
      setLoading(false);
    }
  };

  const handleOpen = (view, pageData = null) => {
    setCurrentModalView(view);
    setSelectedPage(pageData);
    setIsOpen(true);
  };

  const handleClose = () => {
    setIsOpen(false);
    setSelectedPage(null); // Clear selected page on close
  };

  const actionColumn = [
    {
      field: "action",
      headerName: "",
      width: 160,
      headerAlign: "center",
      align: "center",
      flex: 1,

      renderCell: (params) => {
        return (
          <div
            className="cell-action"
            style={{ display: "flex", justifyContent: "flex-end" }}
          >
            <div
              className="cell-btn"
              onClick={() => {
                // View page data
                handleOpen("viewPage", params.row);
              }}
            >
              <img src={ShowUser} alt="" />
            </div>
            <div
              className="cell-btn"
              onClick={() => {
                // Edit page data
                handleOpen("editPage", params.row);
              }}
            >
              <img src={EditUser} alt="" />
            </div>
            <div
              className="cell-btn"
              onClick={() => {
                // Set the item to delete
                setItemToDelete(params.row);
                setOpenDelete(true);
              }}
            >
              <img src={DeleteUser} alt="" />
            </div>
          </div>
        );
      },
    },
  ];

  return (
    <div className="departments-container ">
      <div className="actions-container">
        <div className="btns-container"></div>

        <BlueButton
          text="اضافة صفحة جديد"
          size={isMobile ? "full" : isTablet ? "fit" : "large"}
          variant="fill"
          onClick={() => handleOpen("createPage")}
          icon={<img src={AddGif} alt="" />}
        />
      </div>

      <DataGrid
        sx={{ backgroundColor: "white", width: "100%" }}
        autoHeight={true}
        columns={IntroductionPagesColumns.concat(actionColumn)}
        rows={pages.map((row, index) => {
          return { ...row, index: index + 1 };
        })}
        disableVirtualization
        disableColumnFilter
        disableColumnMenu
        hideFooter
        rowHeight={60}
      />

      <SwipeableModals
        open={isOpen}
        onClose={handleClose}
        onOpen={handleOpen}
        currentView={currentModalView}
        initialData={selectedPage} // Pass selected page data to the modal
        refreshData={fetchSocialMedia} // Function to refresh data after creating/editing
      />

      <MessageModals
        open={openDelete}
        currentView="delete"
        route={itemToDelete ? `/slides/${itemToDelete.id}` : ""}
        text="تم الحذف بنجاح"
        onClose={() => {
          setOpenDelete(false);
          setItemToDelete(null); // Clear item to delete on close
        }}
        onDataChange={fetchSocialMedia}
      />
    </div>
  );
};

export default IntroductionPages;
